import * as types from '../types/genreTypes';
import * as genreService from '../../services/genreService';

export const fetchPublicGenres = () => async (dispatch) => {
  dispatch({ type: types.FETCH_GENRES_REQUEST });
  try {
    const data = await genreService.getPublicGenres();
    const items = (data.items || []).map((g) => ({
      slug: g.slug,
      name: g.name,
      desc: g.description || '',
    }));
    dispatch({ type: types.FETCH_GENRES_SUCCESS, payload: { items, source: 'api' } });
  } catch (err) {
    dispatch({ type: types.FETCH_GENRES_FAILURE, payload: err?.message || 'Failed to load genres' });
  }
};
